import { type Coordinate, type GoogleGeocoderAddressComponent, type GooglePlaceResult, getLicensePlateOrCobliIdOrPlaceholder, type Vehicle } from '@cobliteam/common-types';
import { GeocoderAddressComponentTypes, type InputDestinationAPI } from './Definitions';

export const DEFAULT_PAGE_SIZE = 2147483647;
export const DEFAULT_PAGE = 0;

export const mapAddressComponents = (addressComponents: GoogleGeocoderAddressComponent[]) =>
  Object.values(GeocoderAddressComponentTypes).reduce((result: Partial<Record<GeocoderAddressComponentTypes, string>>, value: GeocoderAddressComponentTypes) => {
    const addressComponent = addressComponents.find((component) => component.types[0] === value);

    if (addressComponent) {
      result[value] = addressComponent.short_name;
    }

    return result;
  }, {});

export const getAddressComponent = (componentType: GeocoderAddressComponentTypes, componentName: string): GoogleGeocoderAddressComponent => ({
  short_name: componentName,
  long_name: componentName,
  types: [componentType],
});

export const addressComponentConcat = (divider: string, componentOne?: string, componentTwo?: string) => {
  if (!(componentOne || componentTwo)) {
    return undefined;
  }
  return `${componentOne || ''}${componentOne && componentTwo ? divider : ''}${componentTwo || ''}`;
};

export const getFormattedAddress = (inputDestination: InputDestinationAPI) => {
  const { city, state, street_address: streetAddress, neighborhood, postal_code: postalCode, street_complement: streetComplement } = inputDestination;

  const neighborhoodAndCity = addressComponentConcat(', ', neighborhood, city);
  const stateAndPostalCode = addressComponentConcat(', ', state, postalCode);

  const components = [streetAddress, streetComplement, neighborhoodAndCity, stateAndPostalCode];

  return components.filter((component) => component).join(' - ');
};

export const mapCoordinate = (coordinate: Coordinate) => [coordinate.longitude, coordinate.latitude];

export const getVehicleString = (vehicle: Vehicle) => {
  const vehicleInfo = {
    id: (vehicle && getLicensePlateOrCobliIdOrPlaceholder(vehicle)) || 'Sem dispositivo',
    name: vehicle?.driver?.name || 'Sem motorista associado',
  };

  return `${vehicleInfo.id} - ${vehicleInfo.name}`;
};

export const concatSpreadsheetColumns = (row: string[], indexes: number[]) =>
  indexes
    .map((index) => row[index])
    .join(' ')
    .trim();

export const defaultPlace: GooglePlaceResult = {
  name: '',
  formatted_address: '',
};
